export const donutchartConfig = {
    piechartMargin: {top: 10, right: 10, left: 10, bottom: 10},
    pieInnerRadius: '77%',
    pieOuterRadius: '99%',  
    
    middletext1Y: '38%',
    middletext2Y: '50%',
    middletext3Y: '60%',

};



// WEBPACK FOOTER //
// ./src/components/surfamountdonutchart/surfamountdonutchart_config.ts